import { render, staticRenderFns } from "./ProductPriceForm.vue?vue&type=template&id=43109776&scoped=true"
import script from "./ProductPriceForm.vue?vue&type=script&lang=js"
export * from "./ProductPriceForm.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceForm.vue?vue&type=style&index=0&id=43109776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43109776",
  null
  
)

export default component.exports